import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import swal from 'sweetalert2';
import TextareaAutosize from 'vue-textarea-autosize';
import VueLazyload from 'vue-lazyload';
import EventBus from '@/helper/EventBus/eventbus';
import Snotify from 'vue-snotify';
import Multiselect from 'vue-multiselect';
import Lightbox from 'vue-easy-lightbox';
import VueCropper from 'vue-cropper';
import App from './App.vue';
import router from './router';
import store from './store';
import globalMixin from './mixins/globalMixin'; // 全域

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// Package

Vue.use(BootstrapVue);
Vue.use(TextareaAutosize);
Vue.use(Lightbox);
Vue.use(VueLazyload, {
  preload: 1.5,
  loading: require('@/assets/images/default/loading.gif'),
  error: require('@/assets/images/default/defaultImg404.png'),
  attempt: 2,
  listenEvents: ['scroll']
});
Vue.use(Snotify, {
  toast: {
    timeout: 2500,
    showProgressBar: false,
    pauseOnHover: false,
    animation: {
      enter: 'fadeInRight',
      exit: 'fadeOutRight',
      time: 500
    }
  }
});
Vue.use(VueCropper);

Vue.prototype.$companyName = process.env.VUE_APP_COMPANY_NAME;
Vue.prototype.$swal = swal;
Vue.prototype.$EventBus = EventBus;

// Mixin
Vue.mixin(globalMixin);

// Component
Vue.component('multiselect', Multiselect);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
